// 日期,在原有日期基础上,增加days天数,默认增加1天
function addDate(date, days) {
  if (days == undefined || days == '') {
    days = 1
  }
  var date = new Date(date)
  date.setDate(date.getDate() + days)
  var month = date.getMonth() + 1
  var day = date.getDate()
  return date.getFullYear() + '-' + getFormatDate(month) + '-' + getFormatDate(day)
}

// 日期月份/天的显示,如果是1位数,则在前面加上'0'
function getFormatDate(arg) {
  if (arg == undefined || arg == '') {
    return ''
  }

  var re = arg + ''
  if (re.length < 2) {
    re = '0' + re
  }
  return re
}

function formatFullDate(date, includeYear) {
  var month = date.getMonth() + 1
  var monthDay = date.getDate()
  var ts = (month > 9 ? month : '0' + month) + '-' + (monthDay > 9 ? monthDay : '0' + monthDay)
  if (includeYear) {
    return date.getFullYear() + '-' + ts
  }
  return ts
}

function getQueryString(name, url) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = url.search.substr(1).match(reg)
  if (r != null) {
    return unescape(r[2])
  }
  return null
}

function isYearLeap(year) {
  if ((year % 4 == 0 && year % 100 != 0) || (year % 400 == 0)) {
    return true
  }
  return false
}

function getNumberOfDays(date1, date2) {//获得天数
  //date1：开始日期，date2结束日期
  var a1 = Date.parse(new Date(date1))
  var a2 = Date.parse(new Date(date2))
  var day = parseInt((a2 - a1) / (1000 * 60 * 60 * 24))//核心：时间戳相减，然后除以天数
  return day
}

export {
  addDate,
  formatFullDate,
  getQueryString,
  isYearLeap,
  getNumberOfDays
}